<template>
  <div class="head">
    <div class="head__logo" @click="openS">
      <div class="logo-icon"></div>
      <div class="logo-title">Schrödinger</div>
    </div>
    <div class="head__menu">
      <router-link
        v-for="(item, ndx) in menuItems"
        :to="item.route"
        :key="ndx"
        active-class="active"
        class="menu-link"
      >
        {{ item.title }}
      </router-link>
      <div class="x-wrap-icon" @click="openX">
        <div class="x-icon"></div>  
      </div>
    </div>
    <div class="head__menu mob">
      <div class="x-wrap-icon" @click="togglePages">
        <div class="burger-icon"></div>  
      </div>
      <div class="x-wrap-icon" @click="openX">
        <div class="x-icon"></div>  
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const menuItems = ref([
      { title: "Home", route: "/" }, 
      { title: "Copilot", route: "copilot" },
    ]);

    const openS = () => {
      window.open("https://www.ai-schrodinger.com/", "_blank");
    };

    const openX = () => {
      window.open("https://x.com/ai_schrodinger", "_blank");
    };

    const togglePages = () => {
      if (route.name === 'copilot') {
        router.push('/');
      }
      if (route.name === 'home') {
        router.push('/copilot');
      }
    };

    return {
      menuItems,
      openX,
      openS,
      togglePages,
    }
  },
}
</script>
<style lang="scss" scoped>
// @import url("@/assets/colors.scss");

  .head {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    &__logo {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: transform 0.3s ease;
      
      &:hover {
        transform: scale(1.02);
      }

      .logo-icon {
        width: 35px;
        height: 58px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/logo.svg");
        background-size: contain;
      }

      .logo-title {
        font-size: 20px;
        margin-left: 8px;
        font-family: 'YoungSerif-Regular';
        font-weight: bold;
        letter-spacing: -0.3px;
      }
    }

    &__menu {
      display: flex;
      align-items: center;

      &.mob {
        display: none;
      }

      .menu-link {
        font-size: 16px;
        text-decoration: none;
        color: #878585;
        margin-right: 26px;
        font-weight: 500;
        font-family: 'YoungSerif-Regular';
        position: relative;
        
        &:after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 1px;
          background-color: $textBlack;
          transition: width 0.3s ease;
        }
        
        &:hover {
          color: $textBlack;
          
          &:after {
            width: 100%;
          }
        }

        &.active {
          color: $textBlack;
          
          &:after {
            width: 100%;
          }
        }
      }

      .x-wrap-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid $textBlack;
        border-radius: 50%;
        width: 46px;
        height: 46px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background-color: $textBlack;
          
          .x-icon, .burger-icon {
            filter: brightness(0) invert(1);
          }
        }
      }

      .x-icon {
        width: 22px;
        height: 20px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/x.svg");
        background-size: contain;
      }

      .burger-icon {
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/burger.svg");
        background-size: contain;
      }
    }
  }

  @media (max-width: $tabletSize) {
    .head {
      &__logo {
        .logo-icon {
          width: 25px;
          height: 41px;
        }
        
        .logo-title {
          font-size: 18px;
        }
      }

      &__menu {
        display: none;

        .x-wrap-icon {
          width: 36px;
          height: 36px;
          
          &:first-child {
            margin-right: 10px;
          }
        }

        &.mob {
          display: flex;
        }
      }
    }
  }
</style>
